import { render, staticRenderFns } from "./FormProxies.vue?vue&type=template&id=08c12b56"
import script from "./FormProxies.vue?vue&type=script&lang=js"
export * from "./FormProxies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports